export default __webpack_public_path__ + "static/media/bg-header_pc@2x.10612a6c.jpg";